import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';

import { CallBlurType } from '@gem/call/constants';
import { useTranslation } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

import styles from './AnimatedBackgroundPanel.styles.m.css';
import transitions from './AnimatedBackgroundPanel.transitions.m.css';
import { BackgroundPanel } from './components/BackgroundPanel/BackgroundPanel';

const MemberListCSSTransitionClasses = {
  enter: transitions.memberListEnter,
  enterActive: transitions.memberListEnterActive,
  exit: transitions.memberListExit,
  exitActive: transitions.memberListExitActive,
};

interface IAnimatedBackgroundPanelProps {
  isPanelShown: boolean;
  hasVideo: boolean;
  mediaStream: MediaStream | null;
  blurType: CallBlurType;
  onBlurClick(blurType: CallBlurType): void;
  hidePanel(): void;
}

export const AnimatedBackgroundPanel: FC<IAnimatedBackgroundPanelProps> = observer((props) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (props.isPanelShown && !props.hasVideo) {
      props.hidePanel();
      popupsTasks.showAlert(t('call_background_camera_is_off_message'));
    }
  }, [props.isPanelShown, props.hasVideo]);

  return (
    <CSSTransition
      in={props.isPanelShown}
      classNames={MemberListCSSTransitionClasses}
      timeout={100}
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.container}>
        <BackgroundPanel
          hasVideo={props.hasVideo}
          mediaStream={props.mediaStream}
          blurType={props.blurType}
          onBlurClick={props.onBlurClick}
          onClose={props.hidePanel}
        />
      </div>
    </CSSTransition>
  );
});
